'use client'

import Image from 'next/image'
import s from './style.module.css'
import GameLink from '@app/components/custom-links/game-link/'
import SearchCardImage from './search-card-image'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {GameEvent} from '@app/components/header/analytics/events'
import clsx from 'clsx'
import useSearchStore from '../store/search-store'
import {ReffererLayout} from '@app/analytics/analytics-provider/types'

type Props = {
  gameName: string
  gameNameEn: string
  gameCode: string
  propertyCode: string
  playCount: string
  refferalLayout: ReffererLayout
}

const SearchResultCard = ({gameName, gameCode, gameNameEn, propertyCode, playCount, refferalLayout}: Props) => {
  const {setFocused} = useSearchStore()
  return (
    <GameLink
      gameCode={gameCode}
      gameName={gameName}
      propertyCode={propertyCode}
      className='relative group'
      onClick={() => {
        triggerAnalytics(GameEvent.SearchResultClicked, {
          'game-name': gameNameEn,
          'game-code': gameCode,
        }).sendAll()
        setFocused(false)
      }}
      reffererLayout={refferalLayout}
    >
      <div className={clsx(s.hover_bg, 'group-hover:visible invisible')} />
      <div className={s.result_container}>
        <div className={s.game_img_and_text}>
          <SearchCardImage gameName={gameName} gameCode={gameCode} />
          <div className={s.text_container}>
            <p className={s.game_name}>{gameName}</p>
            <p className={s.play_count_text}>{playCount} plays</p>
          </div>
        </div>
        <Image
          src='https://static.gamezop.com/comet/assets/img2/expand-circle-right.svg'
          alt='expand circle icon'
          width={24}
          height={24}
          className='z-5'
        />
      </div>
    </GameLink>
  )
}

export default SearchResultCard
